import axios from "axios";
import AuthService, { TOKEN } from "../AuthService";

const apiUrl = process.env.REACT_APP_API_BASE_URL;
const api_adm = axios.create({
  baseURL: apiUrl,
});

api_adm.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      [403, 401, 400, 500].includes(error.response.status)
    ) { 
      if (
        ["Token non fourni ou invalide", "Token is expired"].includes(
          error.response.data.message
        )
      ) {
        localStorage.removeItem(TOKEN);
        AuthService.logOut();
        AuthService.loginPage();
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

api_adm.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      AuthService.logOut();
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api_adm;
